import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { recentBuyers } from "../data/content";
import { images } from "../data/links";
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let showTimer: number;
    const show = () => {
      setMinutesAgo(1 + Math.floor(Math.random() * 14));
      setOpen(true);
      hideTimer = window.setTimeout(() => {
        setOpen(false);
        showTimer = window.setTimeout(() => {
          setIndex(i => (i + 1) % recentBuyers.length);
          show();
        }, GAP);
      }, VISIBLE_FOR);
    };
    showTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(showTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:bottom-6 sm:left-6 sm:right-auto" aria-live="polite" data-id="element-48" data-mp="1fviv386hszek">
      <AnimatePresence data-id="element-49" data-mp="1ay0mxk0auo7m">
        {open && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl border border-navy/10 bg-white p-3 pr-9 shadow-[0_12px_32px_rgba(14,26,51,0.18)] sm:w-[360px]" data-id="element-50" data-mp="n6v5x1imhpvq">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain" data-id="element-51" data-mp="28mandukft3wm" />
            <div className="min-w-0" data-id="element-52" data-mp="2ao1mavp2hlop">
              <p className="text-sm font-bold leading-snug text-ink" data-id="element-53" data-mp="2fnnyr2x2mxwg">{buyer.name}</p>
              <p className="text-xs text-ink/60" data-id="element-54" data-mp="2fph9ouepw4a9">{buyer.place}</p>
              <p className="mt-0.5 text-[13px] leading-snug text-ink/80" data-id="element-55" data-mp="2ko27kn6hybvj">
                just purchased <span className="font-semibold text-navy" data-id="element-56" data-mp="2pksm362nkzeu">Mastopexy Surgical Blueprint™</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-semibold text-cta" data-id="element-57" data-mp="1rzmy0g64wlrl">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-58" data-mp="1wxy4qi14ug5l" />
                Verified purchase · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-ink/40 transition-colors duration-150 hover:bg-cream hover:text-ink" aria-label="Close notification" data-id="element-59" data-mp="26nhnzosrcc0z">
              <XIcon className="h-4 w-4" data-id="element-60" data-mp="3rhgk54bae0z5" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}